<template>
<!--  <nav>-->
<!--    <router-link to="/">Home</router-link> |-->
<!--    <router-link to="/about">About</router-link>-->
<!--  </nav>-->
  <router-view/>
</template>

<style lang="scss">
@import './assets/fonts/fonts.css';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 0 0 0;
  //background-image: url('./assets/bg_f.png');
  //background-size: cover;
  //background-position: center;
}
.el-main {
  padding: 0;
}
body {
  padding: 0;
  margin: 0;
}

</style>
